// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__2zMbv","menuButton":"menu_menuButton__3IXV6","menuList":"menu_menuList__2_4-R"};